<template>
  <div v-if="validationUrl" class="certificate-validation-qr">
    <img
      v-if="qrDataUrl"
      :src="qrDataUrl"
      alt="QR Code de validação do certificado"
    />

    <div class="certificate-validation-qr-info">
      <strong>VALIDAR</strong>
      <span>{{ publicCode }}</span>
    </div>
  </div>
</template>

<script setup>
import QRCode from "qrcode";
import { ref, watch } from "vue";

const props = defineProps({
  validationUrl: {
    type: String,
    default: "",
  },
  publicCode: {
    type: String,
    default: "",
  },
});

const qrDataUrl = ref("");

watch(
  () => props.validationUrl,
  async (url) => {
    if (!url) {
      qrDataUrl.value = "";
      return;
    }

    qrDataUrl.value = await QRCode.toDataURL(url, {
      errorCorrectionLevel: "M",
      margin: 1,
      width: 220,
      color: {
        dark: "#111827",
        light: "#ffffff",
      },
    });
  },
  { immediate: true }
);
</script>

<style scoped>
.certificate-validation-qr {
  position: absolute;
  right: 33mm; /* lateralidade */
  bottom: 18mm; /* altura */
  z-index: 8;
  width: 50mm;
  min-height: 35mm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.1mm;
  padding: 2mm 1.8mm;

  /* 
  border: 0.4mm solid;
  border-radius: 2.3mm;
  border-image-slice: 1;
  border-image-source: linear-gradient(to left, #622200, #bdad65);
  box-shadow: 0 1.6mm 4.5mm rgba(15, 23, 42, 0.18); 
  */

  background: rgba(255, 255, 255, 0.97);
}

.certificate-validation-qr img {
  width: 24mm;
  height: 24mm;
  object-fit: contain;
  display: block;
}

.certificate-validation-qr-info {
  width: 100%;
  text-align: center;
  line-height: 1.05;
}

.certificate-validation-qr-info strong {
  display: block;
  color: #111827;
  font-family: Arial, sans-serif;
  font-size: 2.4mm;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.certificate-validation-qr-info span {
  display: block;
  margin-top: 0.6mm;
  color: #475569;
  font-family: Arial, sans-serif;
  font-size: 1.65mm;
  font-weight: 700;
  word-break: break-word;
}
</style>
